@if (variant === 'single') {
  @if (orientation === 'horizontal') {
  <ngx-charts-bar-horizontal
    class="block w-full"
    [ngStyle]="height ? { 'height': height } : {}"
    [scheme]="colorScheme"
    [results]="datasets"
    [gradient]="gradient"
    [roundDomains]="roundDomains"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [legend]="showLegend"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [showDataLabel]="showDataLabel"
    [noBarWhenZero]="false"
    [legendTitle]="legendTitle"
    [legendPosition]="legendPosition"
    [animations]="animations"
    (select)="onSelect($event)"
    [id]="chartId">
  </ngx-charts-bar-horizontal>
  } @else {
  <ngx-charts-bar-vertical
    class="block w-full mb-36"
    [scheme]="colorScheme"
    [results]="datasets"
    [gradient]="gradient"
    [roundDomains]="roundDomains"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [legend]="showLegend"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [showDataLabel]="showDataLabel"
    [noBarWhenZero]="false"
    [legendTitle]="legendTitle"
    [legendPosition]="legendPosition"
    [animations]="animations"
    (select)="onSelect($event)"
    [id]="chartId">
  </ngx-charts-bar-vertical>
  }
} @else if (orientation === 'horizontal') {
<ngx-charts-bar-horizontal-2d
  class="block w-full"
  [ngStyle]="height ? { 'height': height } : {}"
  [scheme]="colorScheme"
  [results]="datasets"
  [gradient]="gradient"
  [roundDomains]="roundDomains"
  [xAxis]="showXAxis"
  [yAxis]="showYAxis"
  [legend]="showLegend"
  [showXAxisLabel]="showXAxisLabel"
  [showYAxisLabel]="showYAxisLabel"
  [xAxisLabel]="xAxisLabel"
  [yAxisLabel]="yAxisLabel"
  [showDataLabel]="showDataLabel"
  [legendTitle]="legendTitle"
  [legendPosition]="legendPosition"
  [animations]="animations"
  (select)="onSelect($event)"
  [id]="chartId">
</ngx-charts-bar-horizontal-2d>
} @else {
<ngx-charts-bar-vertical-2d
  class="block w-full mb-36"
  [scheme]="colorScheme"
  [results]="datasets"
  [gradient]="gradient"
  [roundDomains]="roundDomains"
  [xAxis]="showXAxis"
  [yAxis]="showYAxis"
  [legend]="showLegend"
  [showXAxisLabel]="showXAxisLabel"
  [showYAxisLabel]="showYAxisLabel"
  [xAxisLabel]="xAxisLabel"
  [yAxisLabel]="yAxisLabel"
  [showDataLabel]="showDataLabel"
  [legendTitle]="legendTitle"
  [legendPosition]="legendPosition"
  [animations]="animations"
  (select)="onSelect($event)"
  [id]="chartId">
</ngx-charts-bar-vertical-2d>
}
